import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const SelfEvaluation: React.FC = () => {
    const navigate = useNavigate();

    const handleBackToLauncher = () => {
        navigate('/');
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {/* Header */}
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Button
                    variant="contained"
                    startIcon={<ArrowBack />}
                    onClick={handleBackToLauncher}
                    sx={{
                        mb: 2,
                        background: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(10px)',
                        '&:hover': {
                            background: 'rgba(255,255,255,0.3)',
                        },
                    }}
                >
                    Back to Game Launcher
                </Button>
                <Typography
                    variant="h3"
                    component="h1"
                    sx={{
                        color: 'white',
                        fontWeight: 'bold',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                    }}
                >
                    Game Engine Course – Self-Evaluation
                </Typography>
            </Box>

            {/* Content */}
            <Container maxWidth="xl" sx={{ flex: 1, pb: 4 }}>
                <Box
                    sx={{
                        background: 'rgba(255,255,255,0.95)',
                        borderRadius: 2,
                        p: 3,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                        backdropFilter: 'blur(10px)',
                        height: 'calc(100vh - 200px)',
                        overflow: 'auto',
                    }}
                >
                    <iframe
                        src="/self-evaluation.html"
                        style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            borderRadius: '8px',
                        }}
                        title="Game Engine Course Self-Evaluation"
                    />
                </Box>
            </Container>
        </Box>
    );
};

export default SelfEvaluation;
